function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "m33.404 30.694-4.286-4.282v-10.559a1.9065 1.9065 0 0 0-3.8069 0v11.348c0 0.50542 0.19813 0.98457 0.55597 1.3464l4.842 4.8399a1.8923 1.8923 0 0 0 1.3464 0.55799 1.8943 1.8943 0 0 0 1.3464-0.55799 1.8943 1.8943 0 0 0 0.55799-1.3464 1.8903 1.8903 0 0 0-0.55799-1.3464",
  fill: "#49658a",
  fillRule: "evenodd"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m27.5 0.635c-7.176 0-13.923 2.794-18.997 7.868s-7.868 11.821-7.868 18.997 2.794 13.922 7.868 18.997c5.074 5.074 11.821 7.868 18.997 7.868s13.923-2.794 18.997-7.868c5.074-5.075 7.868-11.821 7.868-18.997s-2.794-13.923-7.868-18.997-11.821-7.868-18.997-7.868m0 54.365c-7.345 0-14.251-2.86-19.445-8.055-5.195-5.194-8.055-12.1-8.055-19.445 0-7.346 2.86-14.251 8.055-19.445 5.194-5.195 12.1-8.055 19.445-8.055s14.251 2.86 19.445 8.055c5.195 5.194 8.055 12.1 8.055 19.445 0 7.346-2.86 14.251-8.055 19.445-5.194 5.195-12.1 8.055-19.445 8.055",
  fill: "#d1d1d1",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 27.5,
  cy: 27.5,
  r: 19.19,
  fill: "none",
  stroke: "#42658a",
  strokeWidth: 3.6202
});

const SvgIconResults3 = ({
  svgRef,
  ...props
}) => React.createElement("svg", _extends({
  width: 55,
  height: 55,
  ref: svgRef
}, props), _ref, _ref2, _ref3);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgIconResults3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-results-3.2462b93b.svg";
export { ForwardRef as ReactComponent };